import { useAuth } from '../context/AuthContext';
import { isLaunched } from '../config/features';

const PLAN_FEATURES = {
  preventivi_ai: [
    'quotes', 'clients', 'pipeline', 'follow_ups',
    'ai_survey', 'ai_suggestions', 'pdf_generation',
    'email_sending', 'products', 'tickets', 'assistente',
    'push_notifications', 'pwa'
  ],
  gestionale: [
    'quotes', 'clients', 'pipeline', 'follow_ups',
    'ai_survey', 'ai_suggestions', 'pdf_generation',
    'email_sending', 'products', 'tickets', 'assistente',
    'ddt', 'proforma', 'invoices', 'credit_notes',
    'purchases', 'accounting', 'sdi',
    'whatsapp_notifications', 'push_notifications', 'pwa',
    'passive_invoices'
  ],
  sartoriale: ['all']
};

export function useSubscription() {
  const { user } = useAuth();

  const plan = user?.plan || 'preventivi_ai';
  const trialExpires = user?.trial_expires_at;

  // Check if in trial
  let inTrial = false;
  let trialDaysLeft = 0;
  if (trialExpires) {
    try {
      const expires = new Date(trialExpires);
      const now = new Date();
      if (now < expires) {
        inTrial = true;
        trialDaysLeft = Math.max(0, Math.ceil((expires - now) / (1000 * 60 * 60 * 24)));
      }
    } catch {}
  }

  const canAccess = (feature) => {
    // Modules not launched yet are off for everyone, trial included
    if (!isLaunched(feature)) return false;
    // During trial, everything is accessible
    if (inTrial) return true;

    const features = PLAN_FEATURES[plan] || [];
    return features.includes('all') || features.includes(feature);
  };

  const planName = plan === 'preventivi_ai' ? 'Preventivi & IA'
    : plan === 'gestionale' ? 'Gestionale Completo'
    : plan === 'sartoriale' ? 'Sartoriale'
    : plan;

  return {
    plan,
    planName,
    inTrial,
    trialDaysLeft,
    canAccess,
  };
}
